export function PhoneNumberFilter() {
  return function(input) {
    let ext;

    // Assumes the the extension is the only A-Z character in the number
    let split = (input || '').split(/[a-zA-Z]+/);

    // Strip all non-numeric values from the phone number
    let number = split[0].replace(/\D/g, '').trim();

    // Remove the . if it exists
    if (split[1]) {
      ext = split[1].replace(/^\./, '').trim();
    }

    // Remove country code if it exists
    if (number.length === 11) {
      number = number.substr(1);
    }

    // Exit early if the number is empty
    if (!number) {
      return '';
    }

    // Format the phone number
    let areaCode = number.substr(0, 3);
    let exchange = number.substr(3, 3);
    let subscriber = number.substr(6, 4);
    let formatted = `(${areaCode}) ${exchange}-${subscriber}`;

    // Apply the extension if it exists
    if (ext) {
      formatted += ` x${ext}`;
    }

    return formatted.trim();
  };
}
